class Covidence.Reviewer extends Covidence.RelationalModel
  fullName: ->
    @get("first_name") + " " + @get("last_name")

  showRoBInstruction: ->
    !!@get("show_rob_instruction")

  @calculatedProperties: ["fullName"]

class Covidence.Reviewers extends Backbone.Collection
  model: Covidence.Reviewer
